/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState, useEffect } from "react";

// @mui material components
import Switch from "@mui/material/Switch";
import curved9 from "assets/images/curved-images/curved-6.jpg";
import { Box, Heading } from "rebass";
// Authentication layout components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
// Authentication layout components
import { useTranslation } from "react-i18next";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import CardHome from "./card_home";
import "./loading.css";

function HomeScreen() {
  const [rememberMe, setRememberMe] = useState(true);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [loading, setLoading] = useState(false);
  const Container = styled.div`
    background: #ffffff;
    display: flex;
    justify-content: center; // 1
    flex-flow: row wrap;
    width: 100%;
    height: 100%;
  `;
  const List = styled.div`
    display: flex;
    justify-content: center; // 3
    flex-flow: column wrap;
    align-items: center;
  `;
  const [posts, setPosts] = useState([]);
  const fetchData = async () => {
    // const token = sessionStorage.getItem("token");
    // const headers = { ContentType: `application/json` };
    const response = await fetch("https://trust-cargo.co/anas_backend/api/posts");
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setPosts(data["posts"]);
    setLoading(false);
  };
  useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Welcome To Anas Jweiles
          </Typography>
          <Button
            onClick={() => {
              navigate("/authentication/sign-in");
            }}
            color="inherit"
          >
            Login
          </Button>
        </Toolbar>
      </AppBar>
      {loading ? (
        <div className="loader-container">
          <div className="spinner" />
        </div>
      ) : (
        <List>
          {posts.map((item) => (
            <CardHome title="Anas Jweiles" desc={item.body} images={item.images} />
          ))}
        </List>
      )}
    </div>
  );
}

export default HomeScreen;
